import { useEffect, useRef } from "react";
import { Any } from "@cede/types";

/**
 * Trigger an effect only once when a condition is met.
 *
 * @param effect - The effect to trigger.
 * @param triggerCondition - The condition to trigger the effect or not. (should return true to trigger the effect)
 * @param dependencies - The dependencies to watch for changes
 * @param resetDependencies - if any of these dependencies change, it will be able to trigger the effect again (if the trigger condition is met).
 */
export const useEffectOnce = (
  effect: React.EffectCallback,
  triggerCondition: () => boolean,
  dependencies: Any[],
  resetDependencies: Any[],
) => {
  const hasTriggered = useRef(false);

  useEffect(() => {
    if (triggerCondition() && !hasTriggered.current) {
      hasTriggered.current = true;
      effect();
    }
  }, dependencies);

  useEffect(() => {
    hasTriggered.current = false;
  }, resetDependencies);
};
